import React from "react";
import { useLang } from "../../i18n/LanguageContext";
import { useReveal } from "../../hooks/useReveal";
import { differentiatorImage } from "../../data/projects";

const Differentiators = () => {
  const { t } = useLang();
  const items = t("differentiators.items");
  const { ref, inView } = useReveal();

  return (
    <section
      id="diferenciadores"
      data-testid="differentiators-section"
      className="section-pad bg-[#111] text-white"
    >
      <div className="container-x">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
          <div className="lg:col-span-5">
            <div className="font-mono-label text-[#A89F91] mb-6 flex items-center gap-3">
              <span className="inline-block w-8 h-px bg-[#A89F91]" />
              {t("differentiators.kicker")}
            </div>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl">
              <span className="block">{t("differentiators.title_a")}</span>
              <span className="block text-[#A89F91] italic font-light" style={{ fontFamily: "'Cabinet Grotesk', sans-serif", fontWeight: 400 }}>
                {t("differentiators.title_b")}
              </span>
            </h2>
            <p className="mt-8 text-[#A3A3A3] leading-relaxed max-w-md">
              {t("differentiators.description")}
            </p>

            <div className="mt-10 aspect-[4/3] overflow-hidden hover-zoom hidden lg:block">
              <img
                src={differentiatorImage}
                alt="AARK studio"
                className="w-full h-full object-cover grayscale"
              />
            </div>
          </div>

          <div ref={ref} className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-px bg-[#262626] border border-[#262626] self-start">
            {Array.isArray(items) &&
              items.map((it, i) => (
                <div
                  key={i}
                  data-testid={`differentiator-${i}`}
                  className={`bg-[#111] p-8 md:p-12 fade-in-up ${inView ? "in-view" : ""}`}
                  style={{ transitionDelay: `${i * 100}ms` }}
                >
                  <div className="font-mono-label text-[#A89F91] mb-10">{it.num}</div>
                  <h3 className="font-display text-2xl md:text-3xl text-white mb-4">
                    {it.title}
                  </h3>
                  <p className="text-[#A3A3A3] leading-relaxed">{it.text}</p>
                </div>
              ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Differentiators;
